import { zGraphemeString } from '../../../../validation/grapheme';
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SAS Online Clinic Backend API
 * SASオンラインクリニックのバックエンドAPI仕様。分割YAML構成で管理し、RedoclyとSpectralで検証します。
 * OpenAPI spec version: 0.1.0
 */
import * as zod from 'zod';


/**
 * 検査機器（検査カテゴリ: 未分類/パルス/PG/PSG）の一覧を返します。
 *
 * オプションのフィルタ/検索:
 * - category: 検査カテゴリでフィルタします（UNCLASSIFIED, PULSE, PG, PSG）。
 * - patientNameKana: 患者名（ふりがな）の部分一致検索に使用します。
 * - clinicNameKana: 医療機関名（ふりがな）の部分一致検索に使用します。
 * - PatientOrganizatione: 所属企業名の検索に使用します。
 * - status: 検査機器の状態でフィルタします（PENDING_SHIPMENT|SHIPPED|RETURNED）。
 * - hasResultArrived: 検査レポート到着有無でフィルタします。
 * @summary 検査機器一覧を取得する
 */
export const equipmentListEquipmentQueryPageDefault = 0;
export const equipmentListEquipmentQueryPageMin = 0;

export const equipmentListEquipmentQuerySizeDefault = 20;
export const equipmentListEquipmentQuerySizeMax = 2000;

export const equipmentListEquipmentQuerySortDefault = `createdAt,desc`;
export const equipmentListEquipmentQuerySortRegExp = new RegExp('^(createdAt),(asc|desc)$');
export const equipmentListEquipmentQueryNameKanaMax = 200;

export const equipmentListEquipmentQueryClinicNameKanaMax = 200;




export const EquipmentListEquipmentQueryParams = zod.object({
  "page": zod.number().int().min(equipmentListEquipmentQueryPageMin).default(equipmentListEquipmentQueryPageDefault).describe('取得ページ番号（0開始）'),
  "size": zod.number().int().min(1).max(equipmentListEquipmentQuerySizeMax).default(equipmentListEquipmentQuerySizeDefault).describe('1ページあたりの件数'),
  "sort": zod.string().refine((v) => equipmentListEquipmentQuerySortRegExp.test(v)).default(equipmentListEquipmentQuerySortDefault).describe('ソートキー（Equipment専用）。許可キーは createdAt のみ（例: createdAt,desc）'),
  "category": zod.enum(['UNCLASSIFIED', 'PULSE', 'PG', 'PSG']).optional().describe('検査機器のカテゴリでフィルタします（未分類/パルス/PG/PSG）'),
  "nameKana": zGraphemeString({ min: 1, max: equipmentListEquipmentQueryNameKanaMax }).optional().describe('患者名（ふりがな）での部分一致検索に使用します。'),
  "clinicNameKana": zGraphemeString({ min: 1, max: equipmentListEquipmentQueryClinicNameKanaMax }).optional().describe('医療機関名（ふりがな）での部分一致検索に使用します。'),
  "patientOrganization": zod.union([zod.object({
  "id": zod.string().uuid()
}).strict(),zod.object({
  "name": zGraphemeString({ min: 1 })
}).strict()]).optional().describe('患者フィルタ用の所属組織（id または name のいずれかを指定）'),
  "status": zod.enum(['DOCTOR_SHIPMENT_REQUEST_RECEIVED', 'MANUFACTURER_SHIPMENT_REQUESTED', 'RETURNED', 'MANUFACTURER_SHIPMENT_REQUESTED_REEXAM']).optional().describe('検査機器の状態で絞り込みに使用します。'),
  "hasResultArrived": zod.boolean().optional().describe('検査レポートの到着有無で絞り込みに使用します。')
}).strict()

export const equipmentListEquipmentResponseItemsItemPatientNameMax = 200;

export const equipmentListEquipmentResponseItemsItemAhiOneMin = 0;
export const equipmentListEquipmentResponseItemsItemAhiOneMax = 200;

export const equipmentListEquipmentResponsePagePageMin = 0;

export const equipmentListEquipmentResponsePageSizeMax = 2000;

export const equipmentListEquipmentResponsePageTotalElementsMin = 0;

export const equipmentListEquipmentResponsePageTotalPagesMin = 0;



export const EquipmentListEquipmentResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid().describe('機器ID（UUID）'),
  "category": zod.enum(['PULSE', 'PG', 'PSG']).describe('機器種別（パルス/PG/PSG）'),
  "patientId": zod.string().uuid().describe('患者ID（UUID）'),
  "patientName": zGraphemeString({ min: 1, max: equipmentListEquipmentResponseItemsItemPatientNameMax }).describe('患者氏名'),
  "plannedArrivalDate": zod.union([zod.string().date(),zod.null()]).describe('機材到着予定日（YYYY-MM-DD／未設定はnull）'),
  "plannedReturnDate": zod.union([zod.string().date(),zod.null()]).describe('機材返却予定日（YYYY-MM-DD／未設定はnull）'),
  "returnedDate": zod.union([zod.string().date(),zod.null()]).describe('機材返却日（YYYY-MM-DD／未返却はnull）'),
  "ahi": zod.union([zod.number().min(equipmentListEquipmentResponseItemsItemAhiOneMin).max(equipmentListEquipmentResponseItemsItemAhiOneMax),zod.null()]).optional().describe('AHI値（PG/PSG対象／未取得はnull）'),
  "hasResultArrived": zod.boolean().describe('検査結果到着有無'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('検査機器の一覧項目（取得API用）')),
  "page": zod.object({
  "page": zod.number().int().min(equipmentListEquipmentResponsePagePageMin).describe('現在のページ番号（0開始）'),
  "size": zod.number().int().min(1).max(equipmentListEquipmentResponsePageSizeMax).describe('1ページあたりの件数'),
  "totalElements": zod.number().int().min(equipmentListEquipmentResponsePageTotalElementsMin).describe('全要素数'),
  "totalPages": zod.number().int().min(equipmentListEquipmentResponsePageTotalPagesMin).describe('全ページ数'),
  "hasNext": zod.boolean().describe('次のページがあるか'),
  "hasPrevious": zod.boolean().describe('前のページがあるか')
}).strict().describe('ページングメタ情報')
}).strict()

/**
 * 指定された機器（equipmentId）の詳細情報を返します。
 * 発送先住所には、デフォルトでは患者の住所が設定されます。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*
 * @summary 検査機器の詳細情報を取得する
 */
export const EquipmentGetDetailParams = zod.object({
  "equipmentId": zod.string().uuid().describe('機器ID（UUID）')
}).strict()

export const equipmentGetDetailResponsePatientNameMax = 200;

export const equipmentGetDetailResponsePatientLocalIdMax = 100;

export const equipmentGetDetailResponseDoctorNameMax = 200;

export const equipmentGetDetailResponseShippingAddressMax = 400;

export const equipmentGetDetailResponseAhiOneMin = 0;
export const equipmentGetDetailResponseAhiOneMax = 200;

export const equipmentGetDetailResponseOdiOneMin = 0;
export const equipmentGetDetailResponseOdiOneMax = 200;



export const EquipmentGetDetailResponse = zod.object({
  "id": zod.string().uuid().describe('機器ID（UUID）'),
  "category": zod.enum(['PULSE', 'PG', 'PSG']).describe('機器種別（英語表記: PULSE/PG/PSG）'),
  "deviceName": zod.enum(['PMP_300E', 'WATCHPAT_300', 'SLEEP_PROFILER_PSG2', 'SLEEP_PRO_CORDER_60']).describe('機器名（PG: PMP_300E/ WATCHPAT_300、PSG: SLEEP_PROFILER_PSG2/ SLEEP_PRO_CORDER_60）'),
  "patientId": zod.string().uuid().describe('患者ID（UUID）'),
  "patientName": zGraphemeString({ min: 1, max: equipmentGetDetailResponsePatientNameMax }).describe('患者氏名'),
  "patientLocalId": zGraphemeString({ min: 1, max: equipmentGetDetailResponsePatientLocalIdMax }).describe('患者識別番号（院内ローカルIDなど）'),
  "doctorName": zGraphemeString({ min: 1, max: equipmentGetDetailResponseDoctorNameMax }).describe('発送依頼元医師名'),
  "shippingAddress": zGraphemeString({ min: 1, max: equipmentGetDetailResponseShippingAddressMax }).describe('機器送付先住所（デフォルトは患者の登録済み住所）'),
  "preferredArrivalDate": zod.string().date().describe('機器到着希望日'),
  "deliveryTimeSlot": zod.enum(['BEFORE_NOON', '14_TO_16', '16_TO_18', '18_TO_20', '19_TO_21', 'NO_PREFERENCE']).describe('配達希望時間帯（英語enum）'),
  "status": zod.enum(['DOCTOR_SHIPMENT_REQUEST_RECEIVED', 'MANUFACTURER_SHIPMENT_REQUESTED', 'RETURNED', 'MANUFACTURER_SHIPMENT_REQUESTED_REEXAM']).describe('状態管理'),
  "plannedArrivalDate": zod.union([zod.string().date(),zod.null()]).describe('機材到着予定日（YYYY-MM-DD／未設定はnull）'),
  "plannedReturnDate": zod.union([zod.string().date(),zod.null()]).describe('機材返却予定日（YYYY-MM-DD／未設定はnull）'),
  "returnedDate": zod.union([zod.string().date(),zod.null()]).describe('機材返却日（YYYY-MM-DD／未返却はnull）'),
  "checkupPerformedOn": zod.union([zod.string().date(),zod.null()]).optional().describe('検査実施日（YYYY-MM-DD／未設定はnull）'),
  "ahi": zod.union([zod.number().min(equipmentGetDetailResponseAhiOneMin).max(equipmentGetDetailResponseAhiOneMax),zod.null()]).optional().describe('AHI値（PG/PSG対象／未取得はnull）'),
  "odi": zod.union([zod.number().min(equipmentGetDetailResponseOdiOneMin).max(equipmentGetDetailResponseOdiOneMax),zod.null()]).optional().describe('ODI値（PULSE対象／未取得はnull）'),
  "hasResultArrived": zod.boolean().describe('検査結果到着有無'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('検査機器の詳細項目（ID指定の取得API用）')

/**
 * 指定された機器（equipmentId）の詳細情報のうち、指定された項目のみ部分更新します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*
 * @summary 検査機器の詳細情報を更新する
 */
export const EquipmentUpdateDetailParams = zod.object({
  "equipmentId": zod.string().uuid().describe('機器ID（UUID）')
}).strict()

export const equipmentUpdateDetailBodyShippingAddressMax = 400;

export const equipmentUpdateDetailBodyAhiOneMin = 0;
export const equipmentUpdateDetailBodyAhiOneMax = 200;

export const equipmentUpdateDetailBodyOdiOneMin = 0;
export const equipmentUpdateDetailBodyOdiOneMax = 200;



export const EquipmentUpdateDetailBody = zod.object({
  "shippingAddress": zGraphemeString({ min: 1, max: equipmentUpdateDetailBodyShippingAddressMax }).optional().describe('機器送付先住所（デフォルトは患者の登録済み住所）'),
  "preferredArrivalDate": zod.string().date().optional().describe('機器到着希望日（YYYY-MM-DD）'),
  "deliveryTimeSlot": zod.enum(['BEFORE_NOON', '14_TO_16', '16_TO_18', '18_TO_20', '19_TO_21', 'NO_PREFERENCE']).optional().describe('配達希望時間帯（英語enum）'),
  "status": zod.enum(['DOCTOR_SHIPMENT_REQUEST_RECEIVED', 'MANUFACTURER_SHIPMENT_REQUESTED', 'RETURNED', 'MANUFACTURER_SHIPMENT_REQUESTED_REEXAM']).optional().describe('状態管理（英語enum）'),
  "plannedArrivalDate": zod.union([zod.string().date(),zod.null()]).optional().describe('機材到着予定日（YYYY-MM-DD／未設定はnull）'),
  "plannedReturnDate": zod.union([zod.string().date(),zod.null()]).optional().describe('機材返却予定日（YYYY-MM-DD／未設定はnull）'),
  "returnedDate": zod.union([zod.string().date(),zod.null()]).optional().describe('機材返却日（YYYY-MM-DD／未返却はnull）'),
  "checkupPerformedOn": zod.union([zod.string().date(),zod.null()]).optional().describe('検査実施日（YYYY-MM-DD／未設定はnull）'),
  "ahi": zod.union([zod.number().min(equipmentUpdateDetailBodyAhiOneMin).max(equipmentUpdateDetailBodyAhiOneMax),zod.null()]).optional().describe('AHI値（PG/PSG対象／未取得はnull）'),
  "odi": zod.union([zod.number().min(equipmentUpdateDetailBodyOdiOneMin).max(equipmentUpdateDetailBodyOdiOneMax),zod.null()]).optional().describe('ODI値（PULSE対象／未取得はnull）'),
  "hasResultArrived": zod.boolean().optional().describe('検査結果到着有無')
}).strict().describe('検査機器の詳細情報（部分更新用リクエスト）')

export const equipmentUpdateDetailResponsePatientNameMax = 200;

export const equipmentUpdateDetailResponsePatientLocalIdMax = 100;

export const equipmentUpdateDetailResponseDoctorNameMax = 200;

export const equipmentUpdateDetailResponseShippingAddressMax = 400;

export const equipmentUpdateDetailResponseAhiOneMin = 0;
export const equipmentUpdateDetailResponseAhiOneMax = 200;

export const equipmentUpdateDetailResponseOdiOneMin = 0;
export const equipmentUpdateDetailResponseOdiOneMax = 200;



export const EquipmentUpdateDetailResponse = zod.object({
  "id": zod.string().uuid().describe('機器ID（UUID）'),
  "category": zod.enum(['PULSE', 'PG', 'PSG']).describe('機器種別（英語表記: PULSE/PG/PSG）'),
  "deviceName": zod.enum(['PMP_300E', 'WATCHPAT_300', 'SLEEP_PROFILER_PSG2', 'SLEEP_PRO_CORDER_60']).describe('機器名（PG: PMP_300E/ WATCHPAT_300、PSG: SLEEP_PROFILER_PSG2/ SLEEP_PRO_CORDER_60）'),
  "patientId": zod.string().uuid().describe('患者ID（UUID）'),
  "patientName": zGraphemeString({ min: 1, max: equipmentUpdateDetailResponsePatientNameMax }).describe('患者氏名'),
  "patientLocalId": zGraphemeString({ min: 1, max: equipmentUpdateDetailResponsePatientLocalIdMax }).describe('患者識別番号（院内ローカルIDなど）'),
  "doctorName": zGraphemeString({ min: 1, max: equipmentUpdateDetailResponseDoctorNameMax }).describe('発送依頼元医師名'),
  "shippingAddress": zGraphemeString({ min: 1, max: equipmentUpdateDetailResponseShippingAddressMax }).describe('機器送付先住所（デフォルトは患者の登録済み住所）'),
  "preferredArrivalDate": zod.string().date().describe('機器到着希望日'),
  "deliveryTimeSlot": zod.enum(['BEFORE_NOON', '14_TO_16', '16_TO_18', '18_TO_20', '19_TO_21', 'NO_PREFERENCE']).describe('配達希望時間帯（英語enum）'),
  "status": zod.enum(['DOCTOR_SHIPMENT_REQUEST_RECEIVED', 'MANUFACTURER_SHIPMENT_REQUESTED', 'RETURNED', 'MANUFACTURER_SHIPMENT_REQUESTED_REEXAM']).describe('状態管理'),
  "plannedArrivalDate": zod.union([zod.string().date(),zod.null()]).describe('機材到着予定日（YYYY-MM-DD／未設定はnull）'),
  "plannedReturnDate": zod.union([zod.string().date(),zod.null()]).describe('機材返却予定日（YYYY-MM-DD／未設定はnull）'),
  "returnedDate": zod.union([zod.string().date(),zod.null()]).describe('機材返却日（YYYY-MM-DD／未返却はnull）'),
  "checkupPerformedOn": zod.union([zod.string().date(),zod.null()]).optional().describe('検査実施日（YYYY-MM-DD／未設定はnull）'),
  "ahi": zod.union([zod.number().min(equipmentUpdateDetailResponseAhiOneMin).max(equipmentUpdateDetailResponseAhiOneMax),zod.null()]).optional().describe('AHI値（PG/PSG対象／未取得はnull）'),
  "odi": zod.union([zod.number().min(equipmentUpdateDetailResponseOdiOneMin).max(equipmentUpdateDetailResponseOdiOneMax),zod.null()]).optional().describe('ODI値（PULSE対象／未取得はnull）'),
  "hasResultArrived": zod.boolean().describe('検査結果到着有無'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('検査機器の詳細項目（ID指定の取得API用）')

/**
 * 患者ID・機器種別（PG/PSG）・機器名・医療機関独自の患者識別番号・担当医師ユーザーIDを指定して、機器発送依頼を登録します（POST）。
 * リクエストには含まれませんが、発送先住所として患者の住所をデフォルトで設定してください。
 *
 * 備考:
 * - `testType` により `deviceModelCode` の許容値が変わります（PG: PGモデルコード群、PSG: PSGモデルコード群）。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*
 * @summary 機器発送依頼を登録する
 */
export const equipmentShipmentCreateBodyThreePatientLocalIdMax = 100;



export const EquipmentShipmentCreateBody = zod.unknown().and(zod.unknown()).and(zod.object({
  "patientId": zod.string().uuid().describe('発送対象の患者ID（UUID）'),
  "patientLocalId": zGraphemeString({ min: 1, max: equipmentShipmentCreateBodyThreePatientLocalIdMax }).describe('医療機関独自の患者識別番号（診察券番号など）'),
  "doctorUserId": zod.string().uuid().describe('発送依頼に指定する担当医師のユーザーID（UUID）'),
  "testType": zod.enum(['PG', 'PSG']).describe('機器種別（簡易検査=PG、PSG検査=PSG）'),
  "deviceName": zod.enum(['PMP_300E', 'WATCHPAT_300', 'SLEEP_PROFILER_PSG2', 'SLEEP_PRO_CORDER_60']).describe('機器名（PG: PMP_300E/ WATCHPAT_300、PSG: SLEEP_PROFILER_PSG2/ SLEEP_PRO_CORDER_60）')
}).strict()).describe('機器発送依頼の登録リクエスト')

export const equipmentShipmentCreateResponsePatientLocalIdMax = 100;

export const equipmentShipmentCreateResponseDoctorNameMax = 200;



export const EquipmentShipmentCreateResponse = zod.object({
  "shipmentId": zod.string().uuid(),
  "patientId": zod.string().uuid(),
  "patientLocalId": zGraphemeString({ min: 1, max: equipmentShipmentCreateResponsePatientLocalIdMax }),
  "doctorName": zGraphemeString({ min: 1, max: equipmentShipmentCreateResponseDoctorNameMax }),
  "testType": zod.enum(['PG', 'PSG']),
  "deviceModelCode": zod.enum(['PMP_300E', 'WATCHPAT_300', 'SLEEP_PROFILER_PSG2', 'SLEEP_PRO_CORDER_60']),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().describe('機器発送依頼のレコード')

